import React from 'react';
import Reveal from 'react-awesome-reveal';
import { keyframes } from "@emotion/react";

const fadeInUp = keyframes`
  0% {
    opacity: 0;
    -webkit-transform: translateY(40px);
    transform: translateY(40px);
  }
  100% {
    opacity: 1;
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
`;

const featurebox= () => (
 <div >
            <div className="col-lg-12 col-md-12 mb-12">
                <div className="feature-box f-boxed style-3">
                    <div className="text">
                      <Reveal className='onStep' keyframes={fadeInUp} delay={200} duration={600} triggerOnce>
                        <h3 className="">Merry Terra Christmas Seals are 3,600+ randomely generated NFTs on the Terra blockchain.</h3>
                        <p className="">It was the year 2021 and Christmas was just around the corner. LUNA was reaching new All-Time-Highs everyday and a surge of new NFT projects were being formed on Terra. Yet a group of LUNAtics and NFT manics couldn’t help feeling like something was missing.</p>
                        <p className="">It was Utility. For the NFT ecosystem in the terraverse to keep thriving, we must consider sustainability. We believe that a culture of giving back is key to a truly sustainable ecosystem. Through our Christmas Seals NFTs, We aim to start a virtuous cycle of growth with Angel Protocol.</p>
                      </Reveal>
                    </div>
                    <i className="wm icon_wallet"></i>
                </div>
            </div>
        </div>
);
export default featurebox;